import cn from "classnames";
import { type HTMLAttributes, type PropsWithChildren } from "react";
import "@/styles/froala-minimal.css";

export type FroalaContentProps = Pick<
  HTMLAttributes<HTMLDivElement>,
  "className"
>;

export default function FroalaContent(
  props: PropsWithChildren<FroalaContentProps>,
) {
  const { children, className } = props;

  return <div className={cn("fr-view", className)}>{children}</div>;
}
